import { styled } from '@mui/system'
import { Box, Typography } from '@mui/material'

export const Main = styled(Box)(({ theme }) => ({
  display: 'flex',
  flex: '1',
  flexDirection: 'column',
  gap: theme.spacing(1.5),
  overflow: 'hidden'
}));

export const Site = styled(Typography)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  fontWeight: 500,
  fontSize: 18,
  lineHeight: '22px',
  color: theme.palette.grey[800],
}))

export const Code = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(1),
  fontSize: 16,
  fontWeight: 300,
  lineHeight: '32px',
  color: theme.palette.grey[800],
  backgroundColor: '#F6F7F8',
  borderRadius: '8px',
  padding: theme.spacing(0.2, 1),
  cursor: 'pointer',
  transition: 'opacity 0.2s',
  '&:hover': {
    opacity: 0.8
  }
}))

export const CopyIcon = styled('i')(({ theme }) => ({
  fontSize: '18px',
  color: theme.palette.grey[600],
}))